import { FieldArrayWithId } from "react-hook-form";

// Redux

// Services
import { getTranslateByKey } from "@/main/services/utils";

// Types
import { DynamicReportForm } from "../../../registerDynamicReport";

// Api

// Components
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import { IconButton, TableCell, TableRow } from "@mui/material";

import * as S from "./styles";

interface IPermissionFieldProps {
	fields: FieldArrayWithId<DynamicReportForm, "permissions", "id">[];
	startEdit: (permission: FieldArrayWithId<DynamicReportForm, "permissions", "id">) => void;
	remove: (permission: FieldArrayWithId<DynamicReportForm, "permissions", "id">) => void;
}

function PermissionList({ fields, startEdit, remove }: IPermissionFieldProps) {
	const sizeCollumns = ["20%", "25%", "45%", "80px"];

	const rowHeaders = [
		getTranslateByKey("information.companyType"),
		getTranslateByKey("information.company"),
		getTranslateByKey("information.userGroup"),
		"", // Actions
	];

	function getUserGroupsText(permission: FieldArrayWithId<DynamicReportForm, "permissions", "id">) {
		if (permission.userGroups.length === 0) return getTranslateByKey("information.all");

		const activeUserGroupNames = permission.userGroups
			.filter((userGroup) => userGroup.active)
			.map((userGroup) => userGroup.displayName);

		return activeUserGroupNames.length > 0 ? activeUserGroupNames.join(", ") : "--";
	}

	return (
		<S.PermissionGridArea>
			<BoxGrid rowHeaders={rowHeaders} sizeColumns={sizeCollumns} widthCustom="100%">
				{fields.map((permission) => {
					const userGroupsText = getUserGroupsText(permission);
					return (
						<TableRow id={`id-dynamicReport-PermissionList-${permission.id}`} key={permission.id}>
							<TableCell>{permission.companyType?.value}</TableCell>
							<TableCell>
								{permission.allCompanies ? getTranslateByKey("information.all") : permission.company?.value}
							</TableCell>
							<TableCell>
								<S.UserGroupsColumn title={userGroupsText}>{userGroupsText}</S.UserGroupsColumn>
							</TableCell>
							<TableCell>
								<S.AreaActions>
									<IconButton
										key={permission.id + "edit"}
										id={`id-dynamicReport-PermissionList-edit-${permission.id}`}
										onClick={() => startEdit(permission)}
									>
										<EditIcon />
									</IconButton>
									<IconButton
										key={permission.id + "remove"}
										id={`id-dynamicReport-PermissionList-remove-${permission.id}`}
										onClick={() => remove(permission)}
									>
										<CloseIcon />
									</IconButton>
								</S.AreaActions>
							</TableCell>
						</TableRow>
					);
				})}
			</BoxGrid>
		</S.PermissionGridArea>
	);
}

export default PermissionList;
